module.exports = __webpack_public_path__ + "img/consult_cover_sample.131ad0fa.png";